import PropTypes from 'prop-types';
import React from 'react';
import { browserHistory } from 'react-router';
import LastAuthenticationAttemptStore from '../stores/LastAuthenticationAttemptStore';
import bindReduceStore from '../components/hocs/bindReduceStore.react';

const checkIfAuthenticated = (authenticationSuccess) => {
  if (authenticationSuccess) {
    browserHistory.push('choose');
  } else if (authenticationSuccess === false) {
    // Checking false explicitly so initial state of null doesn't trigger a failed attempt
    browserHistory.push('login');
  }
};

const AuthCallback = ({ authenticationSuccess }) => {
  checkIfAuthenticated(authenticationSuccess);

  return (<div>
    LOADING SCREEN
  </div>);
};

AuthCallback.propTypes = {
  authenticationSuccess: PropTypes.bool,
};

export default bindReduceStore(LastAuthenticationAttemptStore, 'authenticationSuccess', state => state.success)(AuthCallback);
